/**
 * Add app icons to the template cache so they may be referenced from apps.json
 */
export const ACCOUNT_IMAGES_CACHE_PREFIX = 'composer/images/';
export default function cacheAccountIcons($templateCache) {
  'ngInject';

  // (Use the html loader to pull the SVG content directly into the template cache.)
  const requireImages = require.context('!html-loader!./images', true, /\.svg$/);

  _.forEach(requireImages.keys(), img => {
    // Store icons in cache at app-switcher/icons/Box.svg
    // strip off leading ./
    let imgFileName = img.substr(2);
    $templateCache.put(ACCOUNT_IMAGES_CACHE_PREFIX + imgFileName, requireImages(img));
  });
}
